import React, { useState } from 'react';
import RegistrationModal from './RegistrationModal';

const FinalCTA = () => {
  const [showModal, setShowModal] = useState(false);

  const handleRegisterClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <section className="final-cta">
        <div className="container">
          <h2 className="cta-title">Ready to work smarter with AI?</h2>
          <p className="cta-subtext">Seats are limited to keep this session interactive and high-value.</p>
          <button className="cta-button primary" onClick={handleRegisterClick}>
            Register for the Build Lab
          </button>
          <p className="fine-print">You'll receive the Zoom link and resource kit details via email after registration.</p>
        </div>
      </section>
      
      <RegistrationModal 
        isOpen={showModal}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default FinalCTA;
